import { store } from "../Redux/store";
import baseService from "./baseService";

export const getNotifications = async (params = {}) => {
  try {
    const response = await baseService.get('/notifications', {
      params,
      headers: {
        "x-auth-token": store.getState().auth.token,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getUnreadCount = async () => {
  try {
    const response = await baseService.get('/notifications/unread/count');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const markAsRead = async (notificationId) => {
  try {
    const response = await baseService.patch(`/notifications/${notificationId}/read`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const markAllAsRead = async () => {
  try {
    const response = await baseService.patch('/notifications/read/all');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getActivityLogs = async (params = {}) => {
  try {
    const response = await baseService.get('/notifications/activity-logs', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};